import { gql } from "@apollo/client";

export const GET_INSTITUCION = gql`
query GetInstitucion($codigoInstitucion: String!, $idEvaluacion: Int!) {
    institucion (idInstitucion: $codigoInstitucion, idEvaluacion: $idEvaluacion) {
        nombre
        domicilio
        idProvinciaNavigation {
            descripcion
        }
        idLocalidadNavigation {
            descripcion
            codigoPostal
        }
        habitacion
    }
}
`;

export const adaptInstitucion = (institucion) => {
  return {
    direccionInstitucion: !!institucion?.domicilio ? institucion?.domicilio : "",
    provinciaInstitucion: !!institucion?.idProvinciaNavigation?.descripcion ? institucion?.idProvinciaNavigation?.descripcion : "",
    localidadInstitucion: !!institucion?.idLocalidadNavigation?.descripcion ? institucion?.idLocalidadNavigation?.descripcion : "",
    codigoPostalInstitucion: !!institucion?.idLocalidadNavigation?.codigoPostal ? institucion?.idLocalidadNavigation?.codigoPostal : "",
    habitacion: !!institucion?.habitacion ? institucion?.habitacion : ""
  };
};